import * as Sentry from '@sentry/react';
import React from 'react';
import {
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import { PrivateRoute } from './PrivateRoute';
import {
  Reviewers,
  ReviewTime,
  SocialSignIn,
} from '#screens';
import { Github } from '#screens/Auth';
import { SettingsNavigator } from './SettingsNavigator';
import { StatsNavigator } from './StatsNavigator';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export const Main = () => (
  <SentryRoutes>
    <Route
      exact
      path="/home"
      element={<SocialSignIn platform="github" />}
    />
    <Route
      exact
      path="/auth/github"
      element={<Github />}
    />
    <Route
      exact
      path="/charts/reviewers/:data"
      element={<Reviewers />}
    />
    <Route
      exact
      path="/charts/review-time/:data"
      element={<ReviewTime />}
    />
    <Route
      path="*"
      element={<Navigate to="/home" />}
    />
    <Route element={<PrivateRoute />}>
      <Route
        path="/settings/*"
        element={<SettingsNavigator />}
      />
      <Route
        path="/stats/*"
        element={<StatsNavigator />}
      />
      <Route
        path="*"
        element={<Navigate to="/settings/organizations" />}
      />
    </Route>
  </SentryRoutes>
);
